import { Skeleton } from 'src/components/ui/skeleton';

const NotificationSkeleton = () => (
  <div className="tw:border-b tw:border-border-secondary">
    <div className="tw:flex tw:py-m tw:px-s tw:gap-m">
      <Skeleton className="tw:h-10 tw:w-10 tw:shrink-0 tw:rounded-full" />
      <div className="tw:flex tw:flex-1 tw:flex-col tw:gap-3">
        <Skeleton className="tw:h-4 tw:w-2/5" />
        <Skeleton className="tw:h-3 tw:w-full" />
        <Skeleton className="tw:h-3 tw:w-4/5" />
        <Skeleton className="tw:h-3 tw:w-1/3" />
      </div>
    </div>
    <div className="tw:flex tw:gap-m tw:pb-s tw:pl-12">
      <Skeleton className="tw:h-4 tw:w-16" />
      <Skeleton className="tw:h-4 tw:w-6" />
    </div>
  </div>
);

export default NotificationSkeleton;
